import { Component, OnInit, Input } from '@angular/core';
import { IssueOverviewModel, SubTitleWrapper } from 'src/app/classes';
import * as moment from 'moment';

@Component({
  selector: 'app-incident-preview',
  templateUrl: './incident-preview.component.html',
  styleUrls: ['./incident-preview.component.css']
})
export class IncidentPreviewComponent implements OnInit {

  _issue: IssueOverviewModel;
  @Input() set issue(issue: IssueOverviewModel){
    this._issue = issue;
    if(issue){
      if(issue.customer) this.subTitles.push({ value: issue.customer, type: "Kunde" });
      if(issue.category) this.subTitles.push({ value: issue.category, type: "Kategorie" });
      if(issue.state) this.subTitles.push({ value: issue.state, type: "Status" });
      if(issue.issueescalation) this.subTitles.push({ value: moment(issue.issueescalation).format("DD.MM.YYYY HH") + " Uhr", type: "Wunschdatum" });
    }
  }
  get issue(): IssueOverviewModel {
    return this._issue;
  }

  subTitles: SubTitleWrapper[] = [];

  constructor() {

  }

  ngOnInit(): void {
  }

}
